module.exports = __webpack_public_path__ + "img/kefu.47b1cc23.png";